export default __webpack_public_path__ + "static/bgPhone-520cce0333c1707999fe51ec86f4d567.jpg";